import { useChartDisplay } from '../../../../ui-components/data-viz-ui/charts/common/common-chart-utils/use-chart-display-reducer';
import { ComponentStateManager } from '../../../common/types';
import { MultiMetricComparisonVizExternalProps } from '../../types';
import {
  MultiMetricComparisonTableViewActions,
  MultiMetricComparisonTableViewState,
} from './types';

export const useMultiMetricComparisonTableViewStateManager = (
  externalProps: MultiMetricComparisonVizExternalProps,
  persistenceKey: string
): ComponentStateManager<
  MultiMetricComparisonTableViewState,
  MultiMetricComparisonTableViewActions
> => {
  const { displayState, displayActions } = useChartDisplay(
    {
      enablePercentage: false,
      enableStack: false,
      enableLabels: false,
      enableLegend: false,
      enableSortOrder: true,
      enableTableView: true,
      globalDisplayState: externalProps.displayGlobalState,
    },
    persistenceKey
  );

  return {
    state: {
      displayState,
    },
    actions: {
      displayActions: {
        onSelectSortOrder: displayActions.onSelectSortOrder,
        onClickTableView: displayActions.onClickTableView,
      },
    },
  };
};
